/**
 * Created by Administrador on 02/12/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('parameterService', parameterService);

    parameterService.$inject = ['$http', 'CONFIG', 'messageService', 'linkService'];

    function parameterService($http, CONFIG, messageService, linkService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_CONFIG_GENERAL + '/' + CONFIG.API + '/parameter';
        var service = {
            getParametersByGroupParameter: getParametersByGroupParameter,
            updateParameters: updateParameters
        }

        return service;

        function getParametersByGroupParameter(id){
            var urlBase = CONFIG.API_URL + '/' + CONFIG.API_CONFIG_GENERAL + '/' + CONFIG.API + '/groupParameters/';
            return $http.get(urlBase + id)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function updateParameters(parameters, route){
            return $http.put(urlBase, parameters)
                .then(function(response){
                    messageService.registerUpdate('');
                    linkService.reloadRoute(route);
                })
                .catch(function(){
                    messageService.registerUpdateError('');
                });
        }
    };
})();
